import Vue from "vue";
const vm = new Vue();

export const fieldExport = {
    "RECEIPT": [
        { key: "index", field: "index", label: "ลำดับ", sortable: true },
        { key: "paid_at", field: "paid_at", label: "วันที่ออกใบเสร็จ", sortable: true },
        { key: "receipt_no", field: "receipt_no", label: "เลขที่ใบเสร็จ", sortable: true },
        { key: "order_total", field: "order_total", label: "จำนวน", sortable: true ,
            dataFormat: value => {
                return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
            }
        },
        { key: "total_courier_cost", field: "total_courier_cost", label: "ค่าขนส่ง", sortable: true ,
            dataFormat: value => {
                return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
            }
        },
        { key: "total_additional_fuel_charge", field: "total_additional_fuel_charge", label: "ค่าขนส่ง (Additional Fuel Charge)", sortable: true ,
            dataFormat: value => {
                return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
            }
        },
        { key: "total_service", field: "total_service", label: "ค่าบริการ (Inc Vat)", sortable: true ,
            dataFormat: value => {
                return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
            }
        },
        { key: "vat_price", field: "vat_price", label: "Vat", sortable: true ,
            dataFormat: value => {
                return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
            }
        },
        { key: "total_service_exclude_vat", field: "total_service_exclude_vat", label: "ค่าบริการ", sortable: true ,
            dataFormat: value => {
                return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
            }
        },
        { key: "total", field: "total", label: "คิดเป็นเงิน", sortable: true ,
            dataFormat: value => {
                return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
            }
        },
        { key: "total_courier_cost_wht", field: "total_courier_cost_wht", label: "ค่าขนส่ง (หัก 1%)", sortable: true ,
            dataFormat: value => {
                return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
            }
        },
        { key: "total_service_exclude_vat_wht", field: "total_service_exclude_vat_wht", label: "ค่าบริการ (หัก 3%)", sortable: true,
            dataFormat: value => {
                return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
            }
        },
        { key: "total_net_price", field: "total_net_price", label: "เงินที่จะได้รับ (แบบหักภาษี ณ ที่จ่าย)", sortable: true ,
            dataFormat: value => {
                return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
            }
        },
        { key: "manage", field: "", label: "จัดการใบเสร็จ", sortable: true }
    ],
    "RECEIPT_SELF": [
        { key: "index", field: "", label: "ลำดับ", sortable: true },
        { key: "paid_at", field: "paid_at", label: "วันที่ออกใบเสร็จ", sortable: true },
        { key: "receipt_no", field: "receipt_no", label: "เลขที่ใบเสร็จ", sortable: true },
        { key: "total", field: "total", label: "ยอดเงิน (บาท)", sortable: true ,
            dataFormat: value => {
                return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
            }
        },
        { key: "manage", field: "", label: "จัดการใบเสร็จ", sortable: true }
    ],
}

export const fieldShopExport = {
    "RECEIPT": [
        { key: "index", field: "index", label: "ลำดับ", sortable: true },
        { key: "paid_at", field: "paid_at", label: "วันที่ออกใบเสร็จ", sortable: true },
        { key: "shop_code", field: "shop_code", label: "รหัสสาขา", sortable: true },
        { key: "invoice_shop_name", field: "invoice_shop_name", label: "ชื่อสาขา", sortable: true },
        { key: "receipt_no", field: "receipt_no", label: "เลขที่ใบเสร็จ", sortable: true },
        { key: "order_total", field: "order_total", label: "จำนวน", sortable: true ,
            dataFormat: value => {
                return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
            }
        },
        { key: "total_courier_cost", field: "total_courier_cost", label: "ค่าขนส่ง", sortable: true ,
            dataFormat: value => {
                return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
            }
        },
        { key: "total_additional_fuel_charge", field: "total_additional_fuel_charge", label: "ค่าขนส่ง (Additional Fuel Charge)", sortable: true ,
            dataFormat: value => {
                return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
            }
        },
        { key: "total_service", field: "total_service", label: "ค่าบริการ (Inc Vat)", sortable: true ,
            dataFormat: value => {
                return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
            }
        },
        { key: "vat_price", field: "vat_price", label: "Vat", sortable: true ,
            dataFormat: value => {
                return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
            }
        },
        { key: "total_service_exclude_vat", field: "total_service_exclude_vat", label: "ค่าบริการ (EX VAT)", sortable: true ,
            dataFormat: value => {
                return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
            }
        },
        { key: "total", field: "total", label: "เงินที่ได้รับยอดเต็ม", sortable: true ,
            dataFormat: value => {
                return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
            }
        },
        { key: "total_courier_cost_wht", field: "total_courier_cost_wht", label: "ค่าขนส่ง (หัก 1%)", sortable: true ,
            dataFormat: value => {
                return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
            }
        },
        { key: "total_service_exclude_vat_wht", field: "total_service_exclude_vat_wht", label: "ค่าบริการ (หัก 3%)", sortable: true,
            dataFormat: value => {
                return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
            }
        },
        { key: "total_net_wht", field: "total_net_wht", label: "รวมภาษีหัก ณ ที่จ่าย", sortable: true,
            dataFormat: value => {
                return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
            }
        },
        { key: "total_net_price", field: "total_net_price", label: "เงินที่จะได้รับ (แบบหักภาษี ณ ที่จ่าย)", sortable: true ,
            dataFormat: value => {
                return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
            }
        },
        { key: "manage", field: "", label: "จัดการใบเสร็จ", sortable: true }
    ],
    "RECEIPT_SELF": [
        { key: "index", field: "", label: "ลำดับ", sortable: true },
        { key: "paid_at", field: "paid_at", label: "วันที่ออกใบเสร็จ", sortable: true },
        { key: "receipt_no", field: "receipt_no", label: "เลขที่ใบเสร็จ", sortable: true },
        { key: "total", field: "total", label: "ยอดเงิน (บาท)", sortable: true ,
            dataFormat: value => {
                return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
            }
        },
        { key: "manage", field: "", label: "จัดการใบเสร็จ", sortable: true }
    ],
}
